import { defineMessages } from 'react-intl';

export default defineMessages({
    creditDue: {
        id: 'twia.policychange.views.payment.creditDue',
        defaultMessage: 'The premium credit will be distributed across the policy’s remaining scheduled invoices. If there are no scheduled invoices, the premium credit will be refunded.',
    },
    differenceDistributed: {
        id: 'twia.policychange.views.payment.differenceDistributed',
        defaultMessage: 'The premium difference will be distributed across the policy’s remaining scheduled invoices. If there are no scheduled invoices, a new invoice will be generated for the premium difference.'
    },
    changeBound: {
        id: 'twia.policychange.views.payment.changeBound',
        defaultMessage: 'Change Bound'
    },
    invalidBank: {
        id: 'twia.policychange.views.selfservice.pay.Bad Bank Info Title',
        defaultMessage: 'Invalid Bank Information'
    },
    badBank: {
        id: 'twia.policychange.views.selfservice.pay.badBank',
        defaultMessage: 'The routing or account information is incorrect. Please retype valid information.'
    },
    changeBoundMessage: {
        id: 'twia.policychange.views.payment.changeBoundMessage',   
        defaultMessage: 'Change has been bound.'
    },
    confirmTransaction: {
        id: "twia.policychange.residential.views.confirmTransaction",
        defaultMessage: "Confirm Transaction",
    },
    confirmTransactionMsg: {
        id: "twia.policychange.residential.views.confirmTransactionMsg",
        defaultMessage: "This transaction cannot be modified after it has been submitted. Do you want to continue?",
    },
    paymentBuyNow: {
        id: 'policychange.views.payment-details.submit',
        defaultMessage: 'Submit'
    },
    paymentThresholdMsg: {
        id: "twia.policychange.residential.views.paymentThresholdMsg",
        defaultMessage: "Payment amount must be between $3.00 - $99,999.00",
    },
    paymentThresholdMsgR352: {
        id: "twia.policychange.residential.views.paymentThresholdMsgR352",
        defaultMessage: "Payment amount must be between $3.00 - $500,000.00",
    },
    unableToProcessPayment: {
        id: "twia.policychange.payment.error.We are unable to process your payment at this time. Please contact TWIA Agent Services at (800) 788-8247",
        defaultMessage: "We are unable to process your payment at this time. Please contact TWIA Agent Services at (800) 788-8247",
    },
    uwPolicyHold_twia: {
        id: 'twia.quoteandbind.cp.policyChange.views.A policy moratorium is in effect for TWIA due to storm activity. No policies will be processed until after the moratorium is lifted.',
        defaultMessage: 'A policy moratorium is in effect for TWIA due to storm activity. No policies will be processed until after the moratorium is lifted.',
    },
    uwOtherBlockingIssue_twia: {
        id: 'twia.quoteandbind.cp.policyChange.views."Underwriting issues have been raised for this transaction.',
        defaultMessage: 'Underwriting issues have been raised for this transaction.',
    },
    unableToQuote: { // DE18570 - Adding Error Pop-up Details
        id: 'policychange.wizard.common.TWIA.Modal.unableToIssue',
        defaultMessage: 'Unable to issue policy change',
    },
    TWIAIssueErrorMessage: {
        id: 'twia.policychange.wizard.common.modal.twiaIssueErrorMessage',
        defaultMessage: 'An error occurred while attempting to issue.'
    },
});
